import { render, staticRenderFns } from "./ComputerVision.vue?vue&type=template&id=09ad90a0&scoped=true&"
import script from "./ComputerVision.vue?vue&type=script&lang=js&"
export * from "./ComputerVision.vue?vue&type=script&lang=js&"
import style0 from "./ComputerVision.vue?vue&type=style&index=0&id=09ad90a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ad90a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1768404630/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09ad90a0')) {
      api.createRecord('09ad90a0', component.options)
    } else {
      api.reload('09ad90a0', component.options)
    }
    module.hot.accept("./ComputerVision.vue?vue&type=template&id=09ad90a0&scoped=true&", function () {
      api.rerender('09ad90a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Shared/Device/Settings/ComputerVision.vue"
export default component.exports